











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CargaOpenlog} from '@/model/resource/CargaOpenlog'
import {CargaOpenlogCollection} from '@/model/collection/CargaOpenlogCollection'
import {ListCargaOpenlogSchema} from '@/schema/resource/CargaOpenlog/ListCargaOpenlogSchema'
import {CsvCargaOpenlogSchema} from '@/schema/resource/CargaOpenlog/CsvCargaOpenlogSchema'

@Component
export default class ListCargaOpenlogView extends Mixins(MixinQueryRouter) {
  schema = new ListCargaOpenlogSchema()
  collection = new CargaOpenlogCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CargaOpenlog) {
    Helper.pushByName('editCargaOpenlog', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargaOpenlogCollection().clearFilters().addFilter(params)

    await csv.listCsvCargaOpenlog()
    new CsvCargaOpenlogSchema().downloadCsv(csv.all())
  }
}
